( function( app ) {
  const COMPONENT = {
    init: function() {
      const navigation = document.querySelector( '.navigation-three' );
      const mobileCta = navigation?.querySelector( '.navigation-three__mobile-cta' );
      const menuCtas = navigation?.querySelector( '.navigation-three__menu-ctas' );

      if ( navigation && mobileCta ) {
        const updateMobileNavigationOffsets = () => {
          const isMobile = window.matchMedia( '(max-width: 1023px)' ).matches;
          const hasCta = mobileCta.querySelector( 'a' ) !== null;
          const ctaHeight = isMobile && hasCta ? mobileCta.getBoundingClientRect().height : 0;
          const menuCtasHeight = isMobile && menuCtas ? menuCtas.getBoundingClientRect().height : 0;
          const adminBarHeight = isMobile ? ( document.querySelector( '#wpadminbar' )?.getBoundingClientRect().height ?? 0 ) : 0;
          const contentTop = isMobile ? adminBarHeight + navigation.getBoundingClientRect().height : 0;
          const panelTop = Math.max( 0, contentTop - ctaHeight );

          document.documentElement.style.setProperty( '--navigation-three-mobile-cta-height', `${ctaHeight}px` );
          document.documentElement.style.setProperty( '--navigation-three-menu-ctas-height', `${menuCtasHeight}px` );
          document.documentElement.style.setProperty( '--navigation-three-mobile-panel-top', `${panelTop}px` );
          document.documentElement.style.setProperty( '--navigation-three-mobile-content-top', `${contentTop}px` );
        };

        const resizeObserver = new ResizeObserver( updateMobileNavigationOffsets );
        const adminBar = document.querySelector( '#wpadminbar' );
        resizeObserver.observe( navigation );
        resizeObserver.observe( mobileCta );
        if ( menuCtas ) resizeObserver.observe( menuCtas );
        if ( adminBar ) resizeObserver.observe( adminBar );

        const announcementBanner = navigation.querySelector( '#announcement-banner' );
        if ( announcementBanner ) {
          const mutationObserver = new MutationObserver( updateMobileNavigationOffsets );
          mutationObserver.observe( announcementBanner, {attributes: true, attributeFilter: ['class', 'style', 'hidden']} );
        }

        const primaryNav = navigation.querySelector( '.navigation-three__primary-nav' );
        if ( primaryNav ) {
          const menuMutationObserver = new MutationObserver( updateMobileNavigationOffsets );
          menuMutationObserver.observe( primaryNav, {attributes: true, attributeFilter: ['class', 'style', 'hidden']} );
        }

        window.addEventListener( 'resize', updateMobileNavigationOffsets );
        updateMobileNavigationOffsets();
      }

      if ( $( window ).width() > 1024 ) {
        // ADA close menu when focus shifts outside of it
        $( '.navigation-three .primary-menu-item__menu' ).on( 'focusout', function( e ) {
          const $menuItem = $( this );
          const newFocus = e.relatedTarget;
          if ( newFocus === null ) return;
          if ( !$menuItem.has( newFocus ).length ) {
            const $trigger = $( '.primary-menu-item__link.is-open' );
            if ( $trigger.length ) {
              $trigger.trigger( 'click' );
              newFocus.focus();
            }
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'navigation-three', COMPONENT );
} )( app );
